import React from 'react';
import { JSErrorBoundary as FeErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import SsrErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import type { ErrorBoundaryProps } from './types.tsx';

export const ErrorBoundary = ({ children, id, withExperienceTracker }: ErrorBoundaryProps) => {
	if (__SERVER__) {
		return <SsrErrorBoundary id={id}>{children}</SsrErrorBoundary>;
	}

	return (
		<FeErrorBoundary
			id={id}
			packageName="jiraEntry"
			fallback="page"
			withExperienceTracker={withExperienceTracker}
		>
			{children}
		</FeErrorBoundary>
	);
};
